<template>

    <b-modal id="workforce-planning-modal" ref="apprenticeRatioRef" v-model="show" centered
        modal-class="a4-portrait no-header no-footer">
        <div class="p-1 overflow-auto h-100 p-relative">
            <div class="floating-header">
                <a href="#" class="bg-white d-block px-2 py-1 text-orange">Download PDF</a>
                <a href="#" class="bg-white d-block px-2 py-1 ml-1 text-orange" @click="show = false">
                    <i class="fa fa-times" />
                </a>
            </div>
            <div class="d-flex align-items-center p-3 justify-content-start">
                <h5 class="text-nowrap">Apprentice Ratio Report</h5>
                <b-select v-model="selected_week" :options="week_options" class="ml-4 flex-shrink-1 w-auto"></b-select>
            </div>

            <div class="table-responsive p-3">
                <table class="table">
                    <tr class="text-primary">
                        <td>Date</td>
                        <td>Scheduled (workers)</td>
                        <td>Apprentices Required for Compliance</td>
                        <td>Trades Needing Compliance</td>
                        <td>Request Labor Adjustment</td>
                    </tr>
                    <tr v-for="(value, day) in weekly_apprentice_rates[selected_week]" :key="day"
                        class="border-bottom">
                        <td>{{ day }}</td>
                        <td>{{ faker.datatype.number({min: 22, max: 31}) }}</td>
                        <td>{{ fake_apprentices_number[day] }}</td>
                        <td>
                            {{ faker.datatype.number({min: fake_apprentices_number[day] ? 1 : 0, max: fake_apprentices_number[day] }) }}
                        </td>
                        <td>
                            <span v-if="fake_apprentices_number[day]"><button class="btn btn-secondary btn-sm">SEND REQUEST</button></span>
                        </td>
                    </tr>
                </table>
            </div>

        </div>
    </b-modal>
</template>
<script>
import { mapState } from 'vuex';
import faker from 'faker';

export default {
    name: 'WorkforcePlanning',
    computed: {
        ...mapState(['workers', 'companies']),
        apprentice_rates() {
            return this.$store.state.report.apprentice_rates;
        },
        weekly_apprentice_rates() {
            const weekly_rates = [];
            const chunks = this.$finder.chunk(Object.keys(this.apprentice_rates), 14);
            for (let week_index in chunks) {
                const dates = chunks[week_index];
                weekly_rates[week_index] = {};
                for (let date of dates) {
                    weekly_rates[week_index][date] = this.apprentice_rates[date];
                }

            }

            return weekly_rates;
        },
        week_options() {
            return this.weekly_apprentice_rates.map((rate, index) => {
                const key = `${Object.keys(rate)[0]} - ${Object.keys(rate)[6]}`;
                return { value: index, text: key }
            });
        },
        fake_apprentices_number() {
            const numbers = {};
            Object.keys(this.weekly_apprentice_rates[this.selected_week]).forEach(day => {
                numbers[day] = this.get_fake_apprentices_number();
            });
            return numbers;
        }
    },
    data() {
        return {
            selected_week: "0",
            faker: faker,
            show: false,
        }
    },
    methods: {
        get_fake_apprentices_number() {
            const n = Math.random();
            if (n < 0.65) return 0;

            return faker.datatype.number({min: 1, max: 5});
        },
    }
}
</script>